import React from 'react';
import SharedFormHeader from '../components/Common/FormHeader';
import {MdClose} from 'react-icons/md';

// Building blocks for the client new/edit forms. They reproduce the look of
// the catalogue product forms (src/components/CatalogPage/product/NewProductForm.js).

// "‹ Retour | Title | Enregistrer" bar — the shared FormHeader
export const FormHeader = ({backTo, ...props}) => <SharedFormHeader back={backTo} {...props}/>;

export const inputClass = (error) =>
    `w-full px-3 sm:px-4 py-2 sm:py-2.5 text-sm sm:text-base border dark:bg-gray-800 dark:text-white dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 ${
        error
            ? 'border-red-500 focus:ring-red-500 dark:border-red-700'
            : 'border-gray-300 focus:ring-primary focus:border-primary dark:focus:border-primary'
    }`;

export const Field = ({id, label, required, error, children}) => (
    <div>
        <label htmlFor={id} className="text-sm font-medium text-gray-700 dark:text-gray-300 block mb-1">
            {label}{required && <span className="text-red-500"> *</span>} :
        </label>
        {children}
        {error && <p className="text-red-500 text-xs sm:text-sm mt-1">{error.message}</p>}
    </div>
);

// Section separator used between field groups in the catalogue forms
export const Section = ({children}) => (
    <div className="pt-3 sm:pt-4 border-t border-gray-200 dark:border-gray-700 space-y-4">
        {children}
    </div>
);

// Centered photo tile; falls back to the initials on a teal square
export const ClientPhoto = ({image, initials, onPick, onRemove}) => (
    <div className="flex flex-col items-center">
        <div className="relative w-24 h-24 sm:w-32 sm:h-32">
            {image ? (
                <img src={image} alt="Client" onClick={onPick}
                     className="w-24 h-24 sm:w-32 sm:h-32 object-cover rounded-lg shadow-sm cursor-pointer"/>
            ) : (
                <button type="button" onClick={onPick}
                        className="w-24 h-24 sm:w-32 sm:h-32 rounded-lg flex items-center justify-center shadow-sm hover:shadow-md transition-shadow bg-primary text-white text-2xl sm:text-3xl font-bold">
                    {initials || 'Éditer'}
                </button>
            )}
            {image && onRemove && (
                <button type="button" onClick={onRemove} aria-label="Supprimer la photo"
                        className="absolute -top-1 -right-1 sm:-top-2 sm:-right-2 bg-red-500 text-white rounded-full p-1 sm:p-1.5 shadow-sm hover:bg-red-600 transition-colors">
                    <MdClose className="w-3 h-3 sm:w-4 sm:h-4"/>
                </button>
            )}
        </div>
        <span className="text-xs text-gray-500 dark:text-gray-400 mt-2">Cliquez pour modifier</span>
    </div>
);

export const COUNTRY_CODES = [
    {id: '212', name: '+212', flag: '🇲🇦'},
    {id: '216', name: '+216', flag: '🇹🇳'},
    {id: '20', name: '+20', flag: '🇪🇬'},
    {id: '33', name: '+33', flag: '🇫🇷'},
    {id: '34', name: '+34', flag: '🇪🇸'},
    {id: '39', name: '+39', flag: '🇮🇹'},
    {id: '1', name: '+1', flag: '🇺🇸'},
    {id: '44', name: '+44', flag: '🇬🇧'},
    {id: '49', name: '+49', flag: '🇩🇪'},
    {id: '86', name: '+86', flag: '🇨🇳'},
    {id: '91', name: '+91', flag: '🇮🇳'},
];

export const CIVILITES = [
    {id: 'm', name: 'M.'},
    {id: 'mme', name: 'Mme'},
    {id: 'mlle', name: 'Mlle'},
];

export const initialsOf = (first = '', last = '') => `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
